import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { fonts } from '@cobliteam/base-components/src/styles/fonts';

export const tableStyle = css`
  table-layout: fixed;
  margin-top: 20px;
  max-height: calc((75vh - 130px) - 100px);
  display: block;
  overflow: auto;
`;

export const checkboxCell = css`
  width: 30px;
  box-sizing: content-box;
`;

export const row = (hasOdometer: boolean) => css`
  display: flex;
  justify-content: space-between;

  > span {
    margin: auto 0;
    margin-right: 10px;
  }

  span:first-child {
    color: ${colors.gray.default};
    font-weight: ${fonts.weight.medium};
  }

  span:last-child {
    color: ${hasOdometer ? colors.gray.dark : colors.gray.default};
    font-weight: ${fonts.weight.medium};
  }
`;

export const odometer = css`
  width: 200px;
  margin-left: 10px;
`;

export const iconsColumn = css`
  width: 30px;
`;

export const iconsColumnData = css`
  && {
    padding: 0;
  }
`;

export const outterCheckboxWrapper = css`
  > div {
    gap: 0;
  }
`;

export const description = (hasOdometer: boolean) => css`
  margin-top: 5px;
  color: ${hasOdometer ? colors.gray.dark : colors.gray.default};
`;

export const button = css`
  float: right;
`;
